<template>
  <div></div>
</template>

<script>
export default {
  name: "selectOption",
  data() {
    return {};
  },
  props: {
    region_list: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/select-option.vue